import React from 'react';
import classnames from 'classnames';
import { Row, Container } from 'react-bootstrap';
import '../styles/index.scss';
import { TextBlock } from './TextBlock';
import { MediaBlock } from './MediaBlock';
var defaultProps = {
  children: null,
  mediaAlt: 'Default Alt',
  mediaSrc: null,
  mediaCaption: 'Default Caption',
  brand: 'law',
  mediaLeft: true,
  hasShadow: true,
  hasEmbeddedVideo: false
};

/**
 * Content Block Component
 *
 * @param  {GatsbyImage} children - To allow the use of GatsbyImage if Gatsby is available
 * @param  {RichText} heading => The content block header text
 * @param  {RichText} content => The text content
 * @param  {String} mediaAlt => alt for the image
 * @param  {String} mediaAlt => src for the image
 * @param  {String} caption - The text that appears in the image caption
 * @param  {string} brand => The brand the content block should be styled for
 * @param  {string} mediaLeft => Boolean to define if the media goes on the left panel
 * @param  {string} hasShadow => Boolean to define if the component has a shadow
 */
var ContentBlock = function ContentBlock(_ref) {
  var _classnames;
  var heading = _ref.heading,
    content = _ref.content,
    brand = _ref.brand,
    mediaSrc = _ref.mediaSrc,
    mediaAlt = _ref.mediaAlt,
    mediaCaption = _ref.mediaCaption,
    mediaLeft = _ref.mediaLeft,
    hasShadow = _ref.hasShadow,
    children = _ref.children,
    hasEmbeddedVideo = _ref.hasEmbeddedVideo;
  var containerStyling = classnames((_classnames = {
    'py-5 px-0': true
  }, _classnames[brand] = true, _classnames['container-with-shadow'] = hasShadow, _classnames));
  var hasMedia = children || mediaSrc;
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    className: containerStyling
  }, /*#__PURE__*/React.createElement(Row, {
    "data-testid": "content-block",
    className: "m-0 content-block-row"
  }, /*#__PURE__*/React.createElement(TextBlock, {
    heading: heading,
    content: content,
    mediaLeft: mediaLeft,
    hasShadow: hasShadow,
    hasMedia: !!hasMedia
  }), /*#__PURE__*/React.createElement(MediaBlock, {
    brand: brand,
    mediaSrc: mediaSrc,
    mediaAlt: mediaAlt,
    mediaCaption: mediaCaption,
    mediaLeft: mediaLeft,
    hasEmbeddedVideo: hasEmbeddedVideo
  }, children)));
};
ContentBlock.defaultProps = defaultProps;
export { ContentBlock };